import { Fragment, ReactElement, useMemo } from 'react';
import { MarriageDetailNotificationsResidentCrumbs } from 'notifications-from-civil-status/constants/breadcrumb';
import { IdAmbito } from 'shell/constants/id-ambito';
import { MarriageDetailNotificationsResidentSubscriptionCrumbs } from 'subscription/constants/breadcrumb';
import { MarriageDetailNotificationsResidentMutationCrumbs } from 'mutation/constants/research-notifications-civil-status.crumbs';
import { MarriageDetailNotificationsResidentCancellationsCrumbs } from 'cancellations/constants/breadcrumb';
import { getBaseUrl } from 'notifications-from-civil-status/utils/get-base-url';
import { useParams } from 'react-router-dom';
import { MarriageDetailNotificationsResidentCivilStatusCrumbs } from 'civil-status/constants/breadcrumb';
import ResearchMarriageDetailNotificationsShared from 'shell/components/shared/research-notifications/research-marriage/detail';

interface ResearchMarriageDetailNotificationsCivilStatusSharedProps {
  scope?: string;
  isOther?: boolean;
}

const ResearchMarriageDetailNotificationsCivilStatusShared = ({
  scope,
  isOther,
}: ResearchMarriageDetailNotificationsCivilStatusSharedProps): ReactElement => {
  const params = useParams();

  const idNotifica = params.idNotifica || '';
  const idCat = params.idCat || undefined;
  const idAnsc = useMemo(() => {
    return params.id || undefined;
  }, [params.id]);

  const baseUrl: string = useMemo(() => {
    return getBaseUrl(scope, idCat);
  }, [scope]);

  const goBackUrl: string = useMemo(() => {
    return `${baseUrl}/modifica/${idAnsc}/${idNotifica}`;
  }, [baseUrl, idAnsc, idNotifica]);

  const goBackUrlDetail: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/visualizza/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  const items = useMemo(() => {
    if (idCat) {
      return MarriageDetailNotificationsResidentCivilStatusCrumbs(goBackUrl, idCat);
    }

    if (!scope) {
      return MarriageDetailNotificationsResidentCrumbs(goBackUrl);
    }

    switch (scope) {
      case IdAmbito.Iscrizioni:
        return MarriageDetailNotificationsResidentSubscriptionCrumbs(goBackUrl);
      case IdAmbito.Mutazioni:
        return MarriageDetailNotificationsResidentMutationCrumbs(goBackUrl);
      case IdAmbito.Cancellazioni:
        return MarriageDetailNotificationsResidentCancellationsCrumbs(goBackUrl);
      default:
        return [];
    }
  }, [scope, idCat]);

  return (
    <Fragment>
      <ResearchMarriageDetailNotificationsShared
        goBackUrl={goBackUrl}
        goBackUrlDetail={goBackUrlDetail}
        items={items}
        isOther={isOther}
        isFromCivilStatus={Boolean(idCat)}
      />
    </Fragment>
  );
};

ResearchMarriageDetailNotificationsCivilStatusShared.displayName =
  'Research Marriage Detail Notifications CivilStatusShared component';

export default ResearchMarriageDetailNotificationsCivilStatusShared;
